// 剖切相关
const ClipTool = () => {
  return import('../../../components/basic/ClipTool')
}

// 风险隐患
const RiskHiddenDanger = () => {
  return import('../../../components/basic/RiskHiddenDanger')
}

// 风险区域2-14
const JobVisualization = () => {
  return import('../../../components/business/JobVisualization/index')
}

// 风险隐患详情
const DangerHiddenDetails = () => {
  return import('../../../components/business/DangerHiddenDetails/DangerHiddenDetail')
}
// 风险区域详情
const RiskAreaDetails = () => {
  return import('../../../components/business/DangerHiddenDetails/RiskAreaDetail')
}
// 区域风险分级管控清单
const RiskAreaEvalutionStatistics = () => {
  return import('../../../components/business/DangerHiddenDetails/RiskAreaEvalutionStatistics')
}

// 建筑操作
const BuildingOperation = () => {
  return import('../../../components/business/BuildingOperation')
}

// 智能管控大亚湾
const IntelligentControlDyw = () => {
  return import('../../../components/business/IntelligentControlDyw')
}

// 人员信息
const PersonnelInfo = () => {
  return import('../../../components/business/PersonnelInfo')
}

// 电子围栏详情
const ElectronicFenceInfo = () => {
  return import('../../../components/business/ElectronicFenceInfo')
}
// 作业安全详情
const JobCardDetails = () => {
  return import('../../../components/business/components/jobCardDetails')
}
// 巡检点
const InspectPoint = () => {
  return import('../../../components/business/InspectPoint')
}
// 巡检路线
const InspectRoute = () => {
  return import('../../../components/business/InspectRoute/index')
}
// 巡检二级菜单
const InspectRight = () => {
  return import('../../../components/business/InspectRoute/InspectRight')
}

// 电缆桥架
const BridgeCable = () => {
  return import('../../../components/business/BridgeCable/index')
}

// 平台监测
const PlatformMonitor = () => {
  return import('../../../components/business/PlatformMonitor/index')
}
// 巡检一张图
const InspectionAPicture = () => {
  return import('../../../components/business/InspectionAPicture/index')
}
// 巡检一张图-机器人清单
const RobotList = () => {
  return import('../../../components/business/InspectionAPicture/RobotList')
}
// 巡检一张图-传感器清单
const SensorList = () => {
  return import('../../../components/business/InspectionAPicture/SensorList')
}
// 巡检一张图-视频清单
const VideoRecognitionList = () => {
  return import('../../../components/business/InspectionAPicture/VideoRecognitionList')
}
// 巡检一张图-巡检点位清单
const PointList = () => {
  return import('../../../components/business/InspectionAPicture/PointList')
}
// 巡检一张图-巡检记录
const Recording = () => {
  return import('../../../components/business/InspectionAPicture/Recording')
}
// 巡检一张图-巡检异常
const Abnormal = () => {
  return import('../../../components/business/InspectionAPicture/Abnormal')
}
// 安防一张图-摄像头列表
const ScameraList = () => {
  return import('../../../components/business/components/smartSecurity/scameraList')
}
// 安防一张图-门禁道匝列表
const AccessControlGateList = () => {
  return import('../../../components/business/components/smartSecurity/accessControlGateList')
}
// 安防一张图-门禁列表
const AccessDoorControlGateList = () => {
  return import('../../../components/business/components/smartSecurity/accessDoorControlGateList')
}
// 两票作业
const TwoWork = () => {
  return import('../../../components/business/twoVote/TwoWork')
}
// 应急管理dyw
const EmergencyDisposalDyw = () => {
  return import('../../../components/business/EmergencyDisposalDyw/index')
}
// 应急管理dyw-应急响应详情页左
const EmergencyResponseDetailLeft = () => {
  return import('../../../components/business/EmergencyDisposalDyw/EmergencyResponseDetailLeft')
}
// 应急管理dyw-应急响应详情页右
const EmergencyResponseDetailRight = () => {
  return import('../../../components/business/EmergencyDisposalDyw/EmergencyResponseDetailRight')
}
// 应急处置一张图
const EmergencyDisposal = () => {
  return import('../../../components/business/EmergencyDisposal/index')
}
// 应急处置一张图-预案列表
const PlanList = () => {
  return import('../../../components/business/EmergencyDisposal/PlanList')
}
// 应急物资台账
const EmergencyMatter = () => {
  return import('../../../components/business/EmergencyDisposal/EmergencyMatter')
}
// 疏散通道路径
const EscapeRoute = () => {
  return import('../../../components/business/EmergencyDisposal/EscapeRoute')
}
// 安全岛台账
const SafetyIsland = () => {
  return import('../../../components/business/EmergencyDisposal/SafetyIsland')
}
// 应急处置卡
const EmergencyDisposalCard = () => {
  return import('../../../components/business/EmergencyDisposal/EmergencyDisposalCard')
}
// 应急监控
const EmergencyMonitor = () => {
  return import('../../../components/business/EmergencyDisposal/EmergencyMonitor')
}
// 移交对象dyw
const HandoverObjectDyw = () => {
  return import('../../../components/business/HandoverObjectDyw')
}
// 对象信息dyw
const ObjectInfoDyw = () => {
  return import('../../../components/business/ObjectInfoDyw/index')
}
// 移交文档dyw
const HandoverDocumentsDyw = () => {
  return import('../../../components/business/HandoverDocumentsDyw')
}
// 物资详情
const MaterialInfo = () => {
  return import('../../../components/business/EmergencyDisposal/Material')
}
// 缺陷管理
const DefectManage = () => {
  return import('../../../components/business/DefectManage/index')
}
// 缺陷详情
const DefectDetail = () => {
  return import('../../../components/business/DefectManage/DefectDetail')
}
// 进度模拟
const ProgressSimulation = () => {
  return import('../../../components/business/Progress/ProgressSimulation')
}
// 报警消息中心监控列表
const AlarmCenterMonitorListDyw = () => {
  return import('../../../components/business/AlarmCenterMonitorListDyw')
}
// 管线抽离-通用
const PipeExtractionTongre = () => {
  return import('../../../components/business/PipeExtractionTongre/index')
}
const exportComponents = {
  MonitorList: () => {
    return import('../../../components/business/MonitorList/MonitorList')
  },
  TaskInfo: () => {
    return import('../../../components/business/TaskMessage/TaskInfo')
  },
  VideoList: () => {
    return import('../../../components/business/VideoMonitor/VideoList')
  },
  VideoInfo: () => {
    return import('../../../components/business/VideoMonitor/VideoInfo')
  },
  CameraList: () => {
    return import('../../../components/business/MonitorList/CameraList')
  },
  CameraInfo: () => {
    return import('../../../components/business/MonitorList/CameraInfo')
  },
  NearbyCameras: () => {
    return import('../../../components/business/MonitorList/NearbyCameras')
  },
  ModelTree: () => {
    return import('../../../components/basic/ModelTree')
  },
  PreferenceSetting: () => {
    return import('../../../components/basic/PreferenceSetting')
  },
  GlobalSetting: () => {
    return import('../../../components/basic/GlobalSetting')
  },
  UnderClip: () => {
    return import('../../../components/basic/UnderClip')
  },
  ProcessSimulate: () => {
    return import('../../../components/business/ProcessSimulate')
  },
  ProcessSimulateTR: () => {
    return import('../../../components/business/ProcessSimulateTR')
  },
  ProcessSimulateTaskInfo: () => {
    return import('../../../components/business/ProcessSimulateTaskInfo')
  },
  OperationSafetyPage: () => {
    return import('../../../components/business/OperationSafetyPage')
  },

  // 碰撞检查
  CollisionCheck: () => {
    return import('../../../components/business/CollisionCheck/index')
  },
  ActionConfig: () => {
    return import('../../../components/business/CollisionCheck/ActionConfig')
  },
  // 新建碰撞检查
  NewCollisionCheck: () => {
    return import('../../../components/business/CollisionCheck/NewCollisionCheck')
  },

  AllClip: ClipTool,
  PartClipBox: ClipTool,
  ThreePanel: ClipTool,
  JobVisualization,
  RiskHiddenDanger,
  DangerHiddenDetails,
  RiskAreaDetails,
  RiskAreaEvalutionStatistics,
  BuildingOperation,
  PersonPositionDyw: IntelligentControlDyw,
  PersonnelInfo,
  ElectronicFenceInfo,
  JobCardDetails,
  InspectPoint,
  InspectRoute,
  BridgeCable,
  InspectRight,
  PlatformMonitor,
  EmergencyDisposalDyw,
  EmergencyResponseDetailLeft,
  EmergencyResponseDetailRight,
  EmergencyDisposal,
  PlanList,
  EmergencyMatter,
  EscapeRoute,
  SafetyIsland,
  EmergencyDisposalCard,
  EmergencyMonitor,
  TwoWork,
  HandoverObjectDyw,
  ObjectInfoDyw,
  HandoverDocumentsDyw,
  MaterialInfo,
  DefectManage,
  DefectDetail,
  ProgressSimulation,
  InspectionAPicture,
  RobotList,
  VideoRecognitionList,
  SensorList,
  PointList,
  Abnormal,
  Recording,
  AlarmCenterMonitorListDyw,
  PipeExtractionTongre,
  ScameraList,
  AccessControlGateList,
  AccessDoorControlGateList
}

export default exportComponents
